import { render, staticRenderFns } from "./LandingReviewsCarousel.vue?vue&type=template&id=22b0165e&scoped=true"
import script from "./LandingReviewsCarousel.vue?vue&type=script&lang=js"
export * from "./LandingReviewsCarousel.vue?vue&type=script&lang=js"
import style0 from "./LandingReviewsCarousel.vue?vue&type=style&index=0&id=22b0165e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b0165e",
  null
  
)

export default component.exports